import * as React from 'react';

import { Textarea } from './components/ui/textarea.js';
import { cn } from './lib/utils.js';

type DimeTextareaProps = Readonly<
  React.ComponentProps<typeof Textarea> & {
    /** Sits inside the control's top-right corner, such as a completion check. */
    trailing?: React.ReactNode;
  }
>;

export function DimeTextarea({ trailing, className, ...props }: DimeTextareaProps) {
  const textarea = <Textarea {...props} className={cn(trailing ? 'pr-8' : undefined, className)} />;
  if (trailing === undefined) return textarea;
  return (
    <div className="relative">
      {textarea}
      <span className="absolute top-2.5 right-2 flex items-center">{trailing}</span>
    </div>
  );
}
